export default __webpack_public_path__ + "static/media/icon-384x384.b5ceff8e.png";